module.exports = __webpack_public_path__ + "media/frames/frame_brown_vertical-87e635d1.jpg";